export type ReportSection = 'timeaccount' | 'project' | 'planning' | 'pdfconvert' | 'teamleader';

export class ReportResponse {
	report_id: number;
	report_name: string;
	report_template: string;
	report_section: ReportSection;
	report_type: string;
}
